const FIELD_START = 1.05;
const FIELD_STEP = 0.15;
const MAX_FIELDS = 4;
const SKELETON_OFF_S = 0.2;
const VALUE_IN_S = 0.5;
const VALUE_TICK_S = 0.4;
const BOOKING_CARD_REVEAL_MS =
  (FIELD_START + (MAX_FIELDS - 1) * FIELD_STEP + VALUE_IN_S + VALUE_TICK_S) * 1000;

export {
  BOOKING_CARD_REVEAL_MS,
  FIELD_START,
  FIELD_STEP,
  SKELETON_OFF_S,
  VALUE_IN_S,
  VALUE_TICK_S,
};
